angular.module('employeesByArea', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'uiGmapgoogle-maps']);



// WEBPACK FOOTER //
// ./src/app/employees-by-area/employees-by-area.module.js